<div class="permission-table">
  <div class="permission-header">
    <div class="permission-title">
      <span class="icon-file-shield-2-line mr-1.5"></span>
      <span>{{ "dicTable.fleetPermissions" | hardTranslate }}</span>
    </div>
    @if (canAddPermission) {
      <hard-button
        (click)="openAdd()"
        [classBtn]="'!rounded-2xl'"
      >
        <span class="icon-plus mr-1"></span>
        {{ "base.add" | hardTranslate }}
      </hard-button>
    }
  </div>

  <div class="permission-table-wrap">
    @if (!permissions.length) {
      <hard-no-data class="min-h-[50px]"></hard-no-data>
    } @else {
      <table class="permission-table-table">
        <thead>
          <tr>
            <th>{{ "dicTable.user" | hardTranslate }}</th>
            <th>{{ "dicTable.managementType" | hardTranslate }}</th>
            <th>{{ "dicTable.validUntil" | hardTranslate }}</th>
            <th class="actions-th"></th>
          </tr>
        </thead>
        <tbody>
          @for (right of permissions; track $index) {
            <tr>
              <td>
                <div class="user">
                  <span class="avatar avatar-placeholder icon-user"></span>
                  <div class="user-info">
                    <span class="user-name">
                      {{ right.user?.fullName }}
                    </span>
                    <span class="user-email">
                      {{ right.user?.email }}
                    </span>
                  </div>
                </div>
              </td>
              <td>{{ right.fleetManageType?.name | hardTranslate }}</td>

              <td>
                {{
                  right?.expiresAt
                    ? (right.expiresAt
                      | dateFormat: dateFormatEnum.DayMonthYearAndFullTime)
                    : ("dicTable.indefinite" | hardTranslate)
                }}
              </td>
              <td class="actions">
                <div class="actions-group">
                  <hard-button
                    [type]="'icon'"
                    tabindex="-1"
                    [attr.aria-label]="'base.edit' | hardTranslate"
                    (click)="$event.stopPropagation(); openEdit($index)"
                  >
                    <span class="icon-pencil"></span>
                  </hard-button>

                  <hard-button
                    [type]="'icon'"
                    tabindex="-1"
                    [attr.aria-label]="'base.delete' | hardTranslate"
                    (click)="$event.stopPropagation(); delete($index)"
                  >
                    <span class="icon-busket"></span>
                  </hard-button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
</div>
